import PropTypes from 'prop-types';
import React from 'react';
import BookCalculatorMoneyInput from 'book-calculator/components/BookCalculatorMoneyInput';
import { FieldSet } from 'common/components/Form';
import connectToStores from 'fluxible-addons-react/connectToStores';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import { handleUpdatedAttribute } from 'book-calculator/actions/handleUpdatedAttribute';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import { injectIntl } from 'react-intl';

class EditingFieldSet extends React.Component {
    handleUpdate(key, { isChecked, value }) {
        this.context.executeAction(handleUpdatedAttribute, {
            key: key,
            value: {
                is_required: isChecked,
                cost: value,
            },
        });
    }

    render() {
        let { fields } = this.props;
        const { intl, genre } = this.props;
        const fictionWhitelist = ['content_editor', 'proof_reader'];

        if (genre === 'fiction') {
            fields = fields.filter(field => fictionWhitelist.includes(field.key));
        }

        return (
            <FieldSet twoColumn={false}>
                <div className="row">
                    <div className="column">
                        <Matrix large={2} normal={2} medium={2} small={1}>
                            {fields.map(field => (
                                <MatrixItem key={field.key}>
                                    <BookCalculatorMoneyInput
                                        title={intl.formatMessage({
                                            id: `fields.editing.${field.key}.title`,
                                        })}
                                        description={intl.formatMessage({
                                            id: `fields.editing.${field.key}.description`,
                                        })}
                                        value={field.cost}
                                        isChecked={field.is_required}
                                        onChange={({ isChecked, value }) => {
                                            this.handleUpdate(field.key, { isChecked, value });
                                        }}
                                    />
                                </MatrixItem>
                            ))}
                        </Matrix>
                    </div>
                </div>
            </FieldSet>
        );
    }
}

EditingFieldSet.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

export default injectIntl(
    connectToStores(EditingFieldSet, [BookCalculatorAttributesStore], (context, prop) => {
        const attributes = context.getStore(BookCalculatorAttributesStore).getState();

        return {
            genre: attributes['genre'],
            fields: [
                Object.assign(attributes['content_editor'], { key: 'content_editor' }),
                Object.assign(attributes['technical_editor'], { key: 'technical_editor' }),
                Object.assign(attributes['proof_reader'], { key: 'proof_reader' }),
                Object.assign(attributes['indexer'], { key: 'indexer' }),
            ],
        };
    })
);
